import React, { useState } from 'react';
import { DataSource, MapDefinition } from '../../api/mapping/types';
import MapControlButtons from './MapControlButtons';
import LayersPanel from './LayersPanel';
import MapSettingsPanel from './MapSettingsPanel';

interface MapRightControlsProps {
  map: MapDefinition;
  layersPanelVisible: boolean;
  setLayersPanelVisible: (visible: boolean) => void;
  settingsPanelVisible: boolean;
  setSettingsPanelVisible: (visible: boolean) => void;
  isDark: boolean;
  allowSwitchDataSource: boolean;
  currentDataSource: DataSource;
  currentToggles: any[];
  availableVariables: string[] | null;
  activeToggleIds: Set<string>;
  onToggleChange: (toggleId: string, enabled: boolean) => void;
  setCurrentDataSource: (dataSource: DataSource) => void;
  setCurrentMap: (map: MapDefinition) => void;
  controlsRightRef: React.RefObject<HTMLDivElement | null>;
  globalOverlayOpacity: number;
  setGlobalOverlayOpacity: (value: number) => void;
}

export default function MapRightControls({
  map,
  layersPanelVisible,
  setLayersPanelVisible,
  settingsPanelVisible,
  setSettingsPanelVisible,
  isDark,
  allowSwitchDataSource,
  currentDataSource,
  currentToggles,
  availableVariables,
  activeToggleIds,
  onToggleChange,
  setCurrentDataSource,
  setCurrentMap,
  controlsRightRef,
  globalOverlayOpacity,
  setGlobalOverlayOpacity,
}: MapRightControlsProps) {
  const [settingsOpenedFromLayers, setSettingsOpenedFromLayers] = useState(false);
  return (
    <>
      <div ref={controlsRightRef} className="absolute right-4 top-4 z-10">
        {!layersPanelVisible && !settingsPanelVisible ? (
          <MapControlButtons onLayersClick={() => setLayersPanelVisible(true)} />
        ) : layersPanelVisible ? (
          <LayersPanel
            title={map.title}
            isDark={isDark}
            allowSwitchDataSource={allowSwitchDataSource}
            currentDataSource={currentDataSource}
            currentToggles={currentToggles}
            availableVariables={availableVariables ?? undefined}
            activeToggleIds={activeToggleIds}
            onClose={() => setLayersPanelVisible(false)}
            onToggleChange={onToggleChange}
            globalOverlayOpacity={globalOverlayOpacity}
            setGlobalOverlayOpacity={setGlobalOverlayOpacity}
            currentMapId={map.id}
            setCurrentMap={setCurrentMap}
            setCurrentDataSource={setCurrentDataSource}
            onSettingsClick={() => {
              setLayersPanelVisible(false);
              setSettingsPanelVisible(true);
              setSettingsOpenedFromLayers(true);
            }}
          />
        ) : (
          <MapSettingsPanel
            onClose={() => {
              setSettingsPanelVisible(false);
              setSettingsOpenedFromLayers(false);
            }}
            openedFromLayers={settingsOpenedFromLayers}
            onBack={() => {
              setSettingsPanelVisible(false);
              setLayersPanelVisible(true);
              setSettingsOpenedFromLayers(false);
            }}
          />
        )}
      </div>
      {/* Map selection sidebar removed in favor of dropdown in LayersPanel */}
    </>
  );
}
